import { Box, Text, TextButton } from '@wix/design-system';
import React from 'react';
import { useDowngradeModal } from '../../../hooks/useDowngradeModal';
import { SwitchProductModule } from '../../../switch-product.module';
import styles from './Summary.scss';
export const ActionSummary = _ref => {
  let {
    onLinkClick
  } = _ref;
  const {
    t,
    Trans
  } = SwitchProductModule.internals.useTranslations();
  const {
    downgradeDetails
  } = useDowngradeModal();
  const formatPrice = SwitchProductModule.SDK.useFormatPrice();
  const isRefund = (downgradeDetails == null ? void 0 : downgradeDetails.downgradeType) === 'Refund' && downgradeDetails.refundCapabilityType !== 'REFUNDABLE_NEGATIVE_BALANCE';
  const isExtend = (downgradeDetails == null ? void 0 : downgradeDetails.downgradeType) === 'Extend' && !!downgradeDetails.daysAdded;
  const handleLinkClick = urlKey => {
    onLinkClick == null || onLinkClick(urlKey);
    window.open(t(urlKey), '_blank');
  };
  if (isRefund) {
    const refundAmount = formatPrice(downgradeDetails.refundAmount);
    return /*#__PURE__*/React.createElement(Box, {
      direction: "vertical"
    }, /*#__PURE__*/React.createElement(Text, {
      weight: "bold"
    }, /*#__PURE__*/React.createElement(Trans, {
      i18nKey: "change_plan.change_plan_modal.refund_amount",
      values: {
        amount: refundAmount
      },
      components: {
        1: /*#__PURE__*/React.createElement("span", {
          className: styles.successColor
        })
      }
    })), /*#__PURE__*/React.createElement(Text, {
      size: "small"
    }, t('change_plan.change_plan_modal.refund_explanation')), /*#__PURE__*/React.createElement(TextButton, {
      size: "small",
      as: "a",
      onClick: () => handleLinkClick('change_plan.change_plan_modal.refund_help_link_url')
    }, t('change_plan.change_plan_modal.refund_help_link_text')));
  }

  // TODO: Is it repeating? DRY?
  if (isExtend) {
    return /*#__PURE__*/React.createElement(Box, {
      direction: "vertical"
    }, /*#__PURE__*/React.createElement(Text, {
      weight: "bold"
    }, /*#__PURE__*/React.createElement(Trans, {
      i18nKey: "change_plan.change_plan_modal.extend_amount",
      values: {
        days: downgradeDetails.daysAdded
      },
      components: {
        1: /*#__PURE__*/React.createElement("span", {
          className: styles.successColor
        })
      }
    })), /*#__PURE__*/React.createElement(Text, {
      size: "small"
    }, t('change_plan.change_plan_modal.extend_explanation')), /*#__PURE__*/React.createElement(TextButton, {
      size: "small",
      as: "a",
      onClick: () => handleLinkClick('change_plan.change_plan_modal.extend_help_link_url')
    }, t('change_plan.change_plan_modal.extend_help_link_text')));
  }
  return null;
};
//# sourceMappingURL=ActionSummary.js.map